import { Component, input } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';

@Component({
  selector: 'app-product-category-atom',
  templateUrl: './product-category-atom.component.html',
  standalone: false,
})
export class ProductCategoryAtomComponent {
  readonly heading = input.required<string>();
  readonly description = input<string>();
  readonly id = input.required<string>();
  readonly level = input<number>(0);
  readonly categoryNameColor = input<IContentBuilderFieldColor>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  readonly categoryDescriptionColor = input<IContentBuilderFieldColor>({
    value: 'neutral-600',
    type: ColorFieldTypesValues.Palette,
  });

  /**
   * Get CSS classes for heading based on category level
   * Level 1+ categories use smaller font sizes
   */
  get headingClasses(): Record<string, boolean> {
    const isSubCategory = this.level() >= 1;
    return {
      'font-brand': true,
      'text-xl': isSubCategory,
      'lg:text-2xl': isSubCategory,
      'text-2xl': !isSubCategory,
      'lg:text-4xl': !isSubCategory,
    };
  }
}
